import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'customers';

// PAGINATION 
export const paginationCustomers = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND BY ID
export const findCustomerById = async id => {
  try {
    const { data } = await api.get(`/${endPoint}/findById`, {
      params: { id },
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllCustomers = async filters => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createCustomer = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateCustomer = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    if (error.response.data.errors && error.response.data.errors[0].sqlState === 'foreignKeyViolation') {
      message.warning(i18next.t('messages:foreignKeyViolation'));
    } else {
      if (process.env.NODE_ENV === 'development') console.log('error', error);
      errorHandler(error);
    }
  }
};

// DELETE
export const deleteCustomer = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationCustomers.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllCustomers.propTypes = {
  filters: PropTypes.object.isRequired,
};

createCustomer.propTypes = {
  values: PropTypes.object.isRequired,
};

updateCustomer.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteCustomer.propTypes = {
  id: PropTypes.string.isRequired,
};
